export { default } from './Historic'
